(() => {
  'use strict';
  if (window.__SQ_SOCIAL_EMAIL_COPY_MATCH_V3__) return;
  window.__SQ_SOCIAL_EMAIL_COPY_MATCH_V3__ = true;
  window.__SQ_SOCIAL_EMAIL_COPY_MATCH_V2__ = true;

  const EMAIL = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" data-sq-share-icon="email"><rect x="2.75" y="5.25" width="18.5" height="13.5" rx="2"></rect><path d="m4.25 7 7.75 5.75L19.75 7"></path></svg>';
  const COPY = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" data-sq-share-icon="copy"><path d="M10.25 13.75 8.5 15.5a4 4 0 0 1-5.66-5.66l3-3a4 4 0 0 1 5.66 0"></path><path d="m13.75 10.25 1.75-1.75a4 4 0 0 1 5.66 5.66l-3 3a4 4 0 0 1-5.66 0"></path><path d="m8.75 15.25 6.5-6.5"></path></svg>';
  const SELECTOR = '.sq-social-share__item--email,.sq-social-share__item--copy';

  function replaceIcon(button, markup, type) {
    if (!(button instanceof Element)) return;
    const current = button.querySelector('svg');
    if (current?.dataset.sqShareIcon === type) return;
    current?.remove();
    button.insertAdjacentHTML('afterbegin', markup);
  }

  function refine(scope = document) {
    scope.querySelectorAll?.('.sq-social-share__item--email').forEach(button => replaceIcon(button, EMAIL, 'email'));
    scope.querySelectorAll?.('.sq-social-share__item--copy').forEach(button => replaceIcon(button, COPY, 'copy'));
  }

  const containsShare = scope => scope instanceof Element && (scope.matches(SELECTOR) || scope.querySelector(SELECTOR));
  const boot = () => refine(document);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot, { once: true }) : boot();
  document.addEventListener('shopify:section:load', event => {
    if (containsShare(event.target)) refine(event.target);
  });
})();
